import { useState } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { Cost } from '@r1-frontend/ui-react/experimental/purchase/cost';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';
import { monthPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';

export type TTariffDetailedInfoProps = {
    period: number,
    startPrice: number,
    finalPrice: number,
};

const periodText = getPluralize(monthPluralize);

const TariffDetailedInfo = (
    {
        period,
        startPrice,
        finalPrice,
    }: TTariffDetailedInfoProps,
): JSX.Element => {
    const [isOpen, changePopupState] = useState(false);

    const handleClosePopup = () => {
        changePopupState(false);
    };

    const handleOpenPopup = () => {
        changePopupState(true);
    };

    return (
        <>
            <ControlElement type={'large'} Icon={InfoCircleFlip} onClick={handleOpenPopup}>
                Цена на {period} месяца, далее <Cost isMonthly={true}>{finalPrice}</Cost>
            </ControlElement>

            <DefaultPopup isOpen={isOpen} onClose={handleClosePopup}>
                <IndentContainer $desktop={[32]} $mobile={[24]}>
                    <TextWrapper>
                        <H3>Условия промо-периода</H3>
                        <Paragraph4 $color={COLORS.TextInfo}>
                            Первые {period}&nbsp;{periodText(period)} после подключения стоимость тарифа будет{'\n\r'}
                            <Cost isMonthly={true}>{startPrice}</Cost>,&nbsp; далее <Cost isMonthly={true}>{finalPrice}</Cost>.
                        </Paragraph4>
                    </TextWrapper>

                    <ButtonGroup>
                        <Button bType={'action'} size={'large'} onClick={handleClosePopup}>Закрыть</Button>
                    </ButtonGroup>
                </IndentContainer>
            </DefaultPopup>
        </>
    );
};

export default TariffDetailedInfo;
